<!-- SubscriptionMPForm.vue -->

<script setup>
import { useUserStore } from "@/stores/useUserStore";
import { storeToRefs } from "pinia";

import PaymentPix from "./PaymentPix.vue";
import CardOneTimeBrick from "./CardOneTimeBrick.vue";
import CardRecurringBrick from "./CardRecurringBrick.vue";

// ✅ MUDANÇA: Desestruturação direta das props para evitar a variável 'props' não utilizada
const { 
  selectedPlan, 
  mode, 
  cpf, 
  isPixDisabled, 
  couponCode, 
  finalPrice, 
  couponApplyToAllCycles 
} = defineProps({
  selectedPlan: { type: Object, required: true },
  mode: { type: String, required: true }, // 'pix_onetime' | 'card_onetime' | 'card_recurring'
  cpf: { type: String, default: "" },
  isPixDisabled: { type: Boolean, default: false },
  couponCode: { type: String, default: "" },
  finalPrice: { type: Number, default: null },
  couponApplyToAllCycles: { type: Boolean, default: false },
});

const emit = defineEmits([
  "subscription-result",
  "card-loading-change", 
]);

const userStore = useUserStore();
const { currentUser } = storeToRefs(userStore);

function onSubscriptionResult(result) {
  emit("subscription-result", result);
}

function onCardLoadingChange(isLoading) {
  emit("card-loading-change", isLoading);
}
</script>

<template>
  <div class="mt-4 space-y-6">
    <div v-if="currentUser && selectedPlan" class="mt-2">
      
      <PaymentPix
        v-if="mode === 'pix_onetime' && !isPixDisabled"
        :plan="selectedPlan"
        :user="currentUser"
        :cpf="cpf"
        :coupon-code="couponCode"
        :final-price="finalPrice"
        @subscription-result="onSubscriptionResult"
      />

      <CardOneTimeBrick
        v-if="mode === 'card_onetime'"
        :plan="selectedPlan"
        :user="currentUser"
        :coupon-code="couponCode"
        :final-price="finalPrice"
        @subscription-result="onSubscriptionResult"
        @loading-change="onCardLoadingChange"
      />

      <CardRecurringBrick
        v-if="mode === 'card_recurring'"
        :plan="selectedPlan"
        :user="currentUser"
        :coupon-code="couponCode"
        :final-price="finalPrice"
        :coupon-apply-to-all-cycles="couponApplyToAllCycles"
        @subscription-result="onSubscriptionResult"
      />
    </div>
  </div>
</template>